"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEEinbauart = void 0;
var AEEinbauart;
(function (AEEinbauart) {
    AEEinbauart["freitragend"] = "F";
    AEEinbauart["gleitend"] = "G";
    AEEinbauart["haengend"] = "H";
    AEEinbauart["stehend"] = "S";
})(AEEinbauart = exports.AEEinbauart || (exports.AEEinbauart = {}));
//# sourceMappingURL=AEEinbauart.js.map